<div breadcrumbs [option]='breadcrumbOptions'></div>
<h1 prog-title>Programs</h1>
@if (programs) {
<div program-setting>
  <div>
    <div program-list>
      <div head [attr.mode]="headmode">
        <div left></div>
        <div right>
          <span><img src="assets/icons/settings-table-white.svg" alt=""></span>
          <span>Program Settings Mode</span>
          @if (popover) {
          <section cancel-msg>
            <div>
              <span>Are you sure you want to cancel and lose changes?</span>
              <article>
                <button (click)="cancel(false)">Cancel</button>
                <button (click)="keepediting()">Keep Editing</button>
              </article>
            </div>
          </section>
          }
          @if (!isDisplay) {
          <figure>
            <button cancel (click)="cancel(true)">Cancel</button>
            <button save (click)="save()" [disabled]="isFormInvalid()">Save</button>
          </figure>
          }
          @if (isDisplay) {
          <span>
            <i class="material-icons" (click)='toggleheader()'>clear</i>
          </span>
          }
        </div>
        <span><img src="assets/icons/programs-title.svg" alt=""></span>
        <div class="program-header">
          <!-- LEFT -->
          <div class="program-title">

            <span>Your Programs</span>
          </div>
          <!-- RIGHT -->
          <div class="program-actions">
            <!-- SIMPLE SEARCH (no mat-form-field) -->
            <div class="search-box" role="search">
              <span class="search-icon material-icons">search</span>
              <input class="search-input" type="search" placeholder="Search programs" [(ngModel)]="searchTerm"
                maxlength="250" />
            </div>
            <!-- FILTERS -->
            <app-filter *ngIf="role === 'admin'" class="filter-wrapper" [filterInput]="filterInput"
              (appliedDateFilter)="appliedDateFilter($event)" (clearFilter)="resetToDefault()"
              [displayFilter]="showFilter"></app-filter>

          </div>
        </div>

        <div close class="undo">
          @if (isSaved) {
          <span save>Saved successfully</span>
          }
          @if (isSaved) {
          <span>
            <i class="material-icons"> check_circle_outline</i>
          </span>
          }
          <span (click)='toggleheader()'>
            <i class="material-icons"> navigate_before</i>
          </span>
          <span><img src="assets/icons/settings-table.svg" alt=""></span>
        </div>
      </div>
      @if (isFilterRes) {
      <div class="no-results-filter">{{filterRes}}</div>
      } @else {
      @if (programs?.length) {
      <table [attr.mode]="tablemode" class="table-fixedheader">
        <thead>
          <th class="edit" (click)="sort('name')">
            <span>Name</span>
            <img [ngClass]="{'active':isNameAsc}" src="assets/icons/sort-by-down.svg" alt="">
          </th>
          <th class="edit" (click)="sort('startDate')">
            <span>Date</span>
            <img [ngClass]="{'active':isDateAsc}" src="assets/icons/sort-by-down.svg" alt="">
          </th>
          @if (role==='admin') {
          <th class="edit" (click)="sort('programType')">
            <span>Program Type</span>
            <img [ngClass]="{'active':programTypeAsc}" src="assets/icons/sort-by-down.svg" alt="">
          </th>
          }
          <th class="edit">
            <span>{{(role==='admin') ? 'Sessions' : 'Events'}}</span>
          </th>
          <th class="edit">
            <span>Attendees</span>
          </th>
          <th class="last-view">
            <div>
              <div>
                <span>Course Registration URL</span>
              </div>
              <div>
                <span>Cvent Registration URL</span>
              </div>
            </div>
          </th>
        </thead>
        <tbody>
          @for (item of programs | searchFilter: searchTerm: 'name'| orderBy: {property: column, direction: direction};
          track item; let i = $index) {
          <tr>
            <td class="edit">
              <div>
                <span>
                  <a
                    [routerLink]="[role === 'admin' ? '/admin/programs' : '/admin/programs-external',item.id, 'program-overview']">{{item?.name}}</a>
                </span>
              </div>
            </td>
            <td class="edit">
              <div>
                <span>{{item.startDate | dateFormat : 'mmddyy'}} - {{item.endDate | dateFormat :
                  'mmddyy'}}</span>
                <span>{{item.startDate | getdays : item.endDate}} days</span>
              </div>
            </td>
            @if (role==='admin') {
            <td class="edit">
              <div>
                <span>{{ item?.programType }}</span>
              </div>
            </td>
            }
            <td class="edit">
              <div>
                <div>
                  <span>{{(item.counts)?.classes || 0}}</span>
                  <span>Classes</span>
                </div>
                <div>
                  <span>{{(item.counts)?.events || 0}}</span>
                  <span>{{(role==='admin') ? 'Session' : 'Events'}}</span>
                </div>
              </div>
            </td>
            <td class="edit">
              <div>
                <div>
                  <span>{{(item.counts)?.participants || 0}}</span>
                  <span>Participants</span>
                </div>
                <div>
                  <span>{{(item.counts)?.facilitators || 0}}</span>
                  <span>Facilitators</span>
                </div>
              </div>
            </td>
            <td class="last-view">
              <div>
                <div>
                  <input class="mat-input-element bottom-grey-border-override form-url" id="{{item.id}}" data-urlName="courseUrl"
                    [attr.data-ceventRegistrationUrl]="item?.programSetting?.ceventRegistrationUrl" #subject
                    placeholder="https://…" maxlength="250" [(ngModel)]="item.programSetting.courseRegistrationUrl"
                    (change)="valuechange($event, i)" (ngModelChange)="validateUrl(i, 'course')">
                  @if (courseUrlErrors[i]) {
                  <div class="error">{{ courseUrlErrors[i] }}</div>
                  }
                </div>
                <div>
                  <input class="mat-input-element bottom-grey-border-override form-url" id="{{item.id}}" data-urlName="cventUrl"
                    [attr.data-courseRegistrationUrl]="item?.programSetting?.courseRegistrationUrl" #subject
                    placeholder="https://…" maxlength="250" [(ngModel)]="item.programSetting.ceventRegistrationUrl"
                    (change)="valuechange($event, i)" (ngModelChange)="validateUrl(i, 'cvent')">
                  @if (cventUrlErrors[i]) {
                  <div class="error">{{ cventUrlErrors[i] }}</div>
                  }
                </div>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
      } @else {
      <p class="background-white m-t-xs">
        <span class="m-l-lg">
          <error-message [errorMessage]="errorMessage"></error-message>
        </span>
      </p>
      }
      }
    </div>
  </div>
</div>
} @else {
@if (!showLoading) {
<div class="loading">
  <mat-spinner></mat-spinner>
</div>
}
}